<template>
  <div class="modal fade show" id="zpmvRegistrationModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content" id="zpmvRegistration">

        <div class="modal-header px-4 pt-4 pb-0 border-0">
          <h1 class="display-3">
            <span v-if="step < 2">Zanechte nám kontakt a my se Vám ozveme</span>
            <span v-else>Děkujeme</span>
          </h1>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-4">
          <div v-if="step === 1">
            <form ref="stepForm" @submit.prevent="submitHandler()">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-4 custom-placeholder">
                    <input type="text"
                           id="fname"
                           class="form-control form-control-lg"
                           v-model.trim="user.firstName"
                           placeholder=" "
                           required
                    >
                    <label class="label-floating" for="fname">
                        <span>
                            Jméno
                        </span>
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-4 custom-placeholder">
                    <input type="text"
                           id="lname"
                           class="form-control form-control-lg"
                           v-model.trim="user.lastName"
                           placeholder=" "
                           required
                    >
                    <label class="label-floating" for="lname">
                        <span>
                            Příjmení
                        </span>
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-4 custom-placeholder">
                    <input type="email"
                           id="mail"
                           class="form-control form-control-lg"
                           v-model.trim="user.email"
                           placeholder=" "
                           required
                    >
                    <label class="label-floating" for="mail">
                        <span>
                            E-mail
                        </span>
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-4 custom-placeholder">
                    <input type="text"
                           id="phone"
                           class="form-control form-control-lg"
                           v-model.trim="user.phone"
                           placeholder=" "
                           required
                    >
                    <label class="label-floating" for="phone">
                        <span>
                            Telefon
                        </span>
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-4 custom-placeholder">
                    <select class="form-control custom-select custom-select-lg" id="clinics" v-model="user.selectedClinicId" required>
                      <option value="" selected disabled hidden></option>
                      <option v-for="clinic in clinics" :value="clinic.Id" :key="clinic.Id">
                        {{ clinic.Name }}
                      </option>
                    </select>
                    <label class="label-floating" for="clinics">
                        <span>
                            Vyberte kliniku
                        </span>
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-4 custom-placeholder">
                    <input type="text"
                           id="birthday"
                           class="form-control form-control-lg"
                           v-model.trim="user.birthDate"
                           placeholder=" "
                           required
                    >
                    <label class="label-floating" for="birthday">
                        <span>
                            Datum narození
                        </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="custom-control custom-checkbox mb-2">
                <input type="checkbox" class="custom-control-input" id="consentUsage" required>
                <label class="custom-control-label" for="consentUsage">
                  Souhlasím s <a :href="consentUsageLink" target="_blank">podmínkami užití služby</a>
                </label>
              </div>
              <div class="custom-control custom-checkbox mb-4">
                <input type="checkbox" class="custom-control-input" id="consentGDPR" required>
                <label class="custom-control-label" for="consentGDPR">
                  Seznámil jsem se s <a :href="consentGdprLink" target="_blank">Informacemi o ochraně osobních údajů</a> a beru je na vědomí
                </label>
              </div>
              <div class="text-right mt-3">
                <button class="btn btn-secondary btn-lg" type="submit" role="button" :disabled="formSending">{{ formSending ? 'Odesílám...' : 'Odeslat' }}</button>
              </div>
              <div class="mt-3 text-gray-lighter font-size-small">
                <p>
                  Tato stránka je chráněna systémem reCAPTCHA od Google s 
                  <a href="https://policies.google.com/privacy" target="_blank" class="text-gray-lighter">
                    <u>ochranou soukromí</u>
                  </a> 
                  a 
                  <a href="https://policies.google.com/terms" target="_blank" class="text-gray-lighter">
                    <u>podmínkami používání</u>
                  </a>.
                </p>
              </div>
            </form>
          </div>
          <div v-if="step === 2">
            <p class="mb-2">Nejpozději následující pracovní den vám zavoláme.</p>
            <p class="pb-3">Na e-mail jsme vám zároveň zaslali potvrzení.</p>
            <button class="btn btn-secondary" type="button" role="button" data-dismiss="modal" aria-label="Close">Zavřít okno</button>
            <div 
              class="alert alert-blue-bright text-body my-3" 
              role="alert" 
              v-show="serviceText.length"
              v-html="serviceText"
            ></div>
          </div>
        </div>
        <div class="bg-light p-4 border-0" v-if="step < 2">
          <div class="row">
            <div class="col-md-3">
              <article class="d-flex align-items-center d-md-block text-md-center my-2 my-md-0">
                <svg class="icon-division text-secondary flex-shrink-0 mb-md-3 mr-3 mr-md-0">
                  <use xlink:href="#icon-file-alt-regular-rounded"></use>
                </svg>
                <p class="text-md-center font-size-lg font-weight-medium">Přechod od současného lékaře vyřídíme za vás</p>
              </article>
            </div>
            <div class="col-md-3">
              <article class="d-flex align-items-center d-md-block text-md-center my-2 my-md-0">
                <svg class="icon-division text-secondary flex-shrink-0 mb-md-3 mr-3 mr-md-0">
                  <use xlink:href="#icon-user-nurse-solid-rounded"></use>
                </svg>
                <p class="text-md-center font-size-lg font-weight-medium">Mnoho odborností v rámci jedné kliniky
                  zařízení</p>
              </article>
            </div>
            <div class="col-md-3">
              <article class="d-flex align-items-center d-md-block text-md-center my-2 my-md-0">
                <svg class="icon-division text-secondary flex-shrink-0 mb-md-3 mr-3 mr-md-0">
                  <use xlink:href="#icon-clock-regular-rounded"></use>
                </svg>
                <p class="text-md-center font-size-lg font-weight-medium">Objednáváme na čas, méně čekáte</p>
              </article>
            </div>
            <div class="col-md-3">
              <article class="d-flex align-items-center d-md-block text-md-center my-2 my-md-0">
                <svg class="icon-division text-secondary flex-shrink-0 mb-md-3 mr-3 mr-md-0">
                  <use xlink:href="#icon-virus-solid-rounded"></use>
                </svg>
                <p class="text-md-center font-size-lg font-weight-medium">Vystavujeme COVID žádanky</p>
              </article>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { load as recaptchaLoad } from 'recaptcha-v3';
import axios from 'axios';

export default {
  data: () => ({
    // !!! if you are changing values below, change RESET values in mounted() as well
    consentGdprLink: '',
    consentUsageLink: '',
    user: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      selectedClinicId: '',
      birthDate: ''
    },
    serviceText: '',
    clinics: [],
    step: 1,
    formSending: false
  }),
  mounted() {
    this.fetchClinics();

    // links to consent files from data atributes
    this.consentGdprLink = $('#ZpmvRegistrationModal').data('consent-gdpr');
    this.consentUsageLink = $('#ZpmvRegistrationModal').data('consent-usage');

    // focus fix for modal inputs
    let pageScroll = 0; 
    $("#zpmvRegistrationModal").on('show.bs.modal', () => {
      // when modal is opened, go to top of page
      pageScroll = $(window).scrollTop();
      window.scroll({
          top: 0
      }); 
    });
    $("#zpmvRegistrationModal").on('hide.bs.modal', () => {
      // when it's closed, return back
      window.scroll({
          top: pageScroll
      });
    });
    // --- focus fix for modal inputs ---

    $("#zpmvRegistrationModal").on('hidden.bs.modal', () => {
        // RESET form when modal is closed
        this.step = 1;
        this.formSending = false;
        this.user = {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          selectedClinicId: '',
          birthDate: ''
        };
        this.serviceText = '';
    });
  },
  methods: {
    fetchClinics() {
      const url = '/umbraco/api/ZpmvRegistration/GetClinics';
      axios
          .get(url)
          .then(response => {
            const { data } = response;
            this.clinics = data;
          })
          .catch(error => console.log(error))
          .finally(() => {
          });
    },
    async submitHandler() {
      this.formSending = true;

      const url = '/umbraco/api/ZpmvRegistration/PostRegistrationForm';
      const data = this.user;
     
      // handle reCaptcha
      let reCaptchaResponse = '';

      // if we have site key
      const siteKey = EUCUtils.getRecaptchaSiteKey();
      if ( siteKey.length )
      {
        // await captcha load
        const recaptcha = await recaptchaLoad(siteKey);

        // get token
        reCaptchaResponse = await recaptcha.execute('zpmv');
      }

      // add reCaptcha token to data
      data.reCaptchaResponse = reCaptchaResponse;

      axios
          .post(url, data)
          .then(response => {
            // set service text for selected clinic
            this.serviceText = this.clinics.find(clinic => {
              return clinic.Id == this.user.selectedClinicId
            }).CustomerServiceText;

            // increase step
            this.step++;
          })
          .catch(error => console.log(error))
          .finally(() => {
            this.formSending = false;

            // RESET form data
            this.user = {
              firstName: '',
              lastName: '',
              email: '',
              phone: '',
              selectedClinicId: '',
              birthDate: ''
            };
          });
    }
  },
}

</script>
